import { type PropsWithChildren, useContext, useEffect, useState } from 'react';

import { HeaderContext } from '../../contexts/HeaderContext';

export const PerformanceCenterBeforeRender = ({ children }: PropsWithChildren) => {
  const {
    setPageMarketplace,
    setPageTitle,
    setPageTimeframe,
    setPageDisplayTimeFrameInterval,
    setPageComparativeSelector,
    setComparativeOptions,
  } = useContext(HeaderContext);

  const [updated, setUpdated] = useState<boolean>(false);

  useEffect(() => {
    setPageMarketplace(true);
    setPageTitle('Performance Center');
    setPageTimeframe('timeframe');
    setPageDisplayTimeFrameInterval(true);
    setComparativeOptions([
      { label: 'Previous Year', value: 'py' },
      { label: 'Previous Month', value: 'pmsd' },
      { label: 'Previous Days', value: 'pd' },
      { label: 'Custom Date', value: 'pc' },
    ]);
    setPageComparativeSelector(true);
    setTimeout(() => setUpdated(true), 0);
  }, [
    setComparativeOptions,
    setPageComparativeSelector,
    setPageDisplayTimeFrameInterval,
    setPageMarketplace,
    setPageTimeframe,
    setPageTitle,
  ]);

  return updated ? children : <></>;
};
